import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=6482ed4b&"
import script from "./Questions.vue?vue&type=script&lang=js&"
export * from "./Questions.vue?vue&type=script&lang=js&"
import style0 from "./Questions.vue?vue&type=style&index=0&id=6482ed4b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports